import { render, staticRenderFns } from "./InvoiceItemModal.vue?vue&type=template&id=59424039"
import script from "./InvoiceItemModal.vue?vue&type=script&lang=js"
export * from "./InvoiceItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports